import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-body-layout',
    template: `

    <div [ngClass]="{'modal-body':isModal}">
      <ng-content></ng-content>
    </div>
  `,
    standalone: false
})
export class BodyLayoutComponent {

  @Input() isModal = false;

}

